import {
  Box,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  stepConnectorClasses,
  styled,
} from "@mui/material";

function StepIcon(props) {
  return <BoxCircle />;
}
export default function WrapperStepper({ steps }) {
  return (
    <Stepper orientation="vertical" connector={<Connector />}>
      {steps.map((step) => (
        <StepStyle>
          <StepLabel StepIconComponent={StepIcon}>
            <Box display="flex" justifyContent="space-between">
              <Typography>{step.label}</Typography>

              <Typography color="text.main" fontWeight={300}>
                {step.description}
              </Typography>
            </Box>
          </StepLabel>
        </StepStyle>
      ))}
    </Stepper>
  );
}

const StepStyle = styled(Step)(({ theme }) => ({
  ".MuiStepLabel-labelContainer": {
    ".Mui-active": { color: `${theme.palette.text.secondary} !important` },
  },
  ".MuiStepLabel-iconContainer": {
    paddingLeft: theme.spacing(1),
  },
}));
const Connector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.secondary.main,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const BoxCircle = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: "currentColor",
  color: theme.palette.secondary.main,
}));
